import axios from 'axios';
import { api, versao } from '../config';
import { getHeaders } from './localStorage';
import errorHandling from './errorHandling';
import { GET_PRODUTOS } from './types';

const MERCHANT_LIST_LIMIT = 500;

export const listProducts = (ordem, atual, limit, loja) => {
	return function (dispatch) {
		return axios
			.get(`${api}/${versao}/api/produtos?offset=${atual}&limit=${limit || MERCHANT_LIST_LIMIT}&loja=${loja}&sortType=${ordem}`, getHeaders())
			.then((response) => {
				dispatch({ type: GET_PRODUTOS, payload: response.data });
				return response.data;
			})
			.catch((error) => {
				errorHandling(error);
				throw error;
			});
	};
};

export const saveProducts = (products, loja) => {
	return function () {
		return axios
			.post(`${api}/${versao}/api/google-applications/atualizar?loja=${loja}`, { products }, getHeaders())
			.then((response) => response.data)
			.catch((error) => {
				errorHandling(error);
				throw error;
			});
	};
};

export const fetchGoogleStatus = (loja) => {
	return function () {
		return axios
			.get(`${api}/${versao}/api/google-applications/status?loja=${loja}`, getHeaders())
			.then((response) => response.data)
			.catch((error) => {
				errorHandling(error);
				throw error;
			});
	};
};

export const removeGoogleProducts = (offerIds, loja) => {
	return function () {
		return axios
			.post(`${api}/${versao}/api/google-applications/remover?loja=${loja}`, { offerIds }, getHeaders())
			.then((response) => response.data)
			.catch((error) => {
				errorHandling(error);
				throw error;
			});
	};
};

export const getProductGoogle = (product, loja) => {
	return function () {
		return axios
			.get(`${api}/${versao}/api/google-applications/get?loja=${loja}&id=${product}`, getHeaders())
			.then((response) => response.data)
			.catch(errorHandling);
	};
};
